if (!customElements.get('variant-exploration')) {
  class VariantExploration extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.selectedImage = this.querySelector('[data-selected-image]');
      this.selectedName = this.querySelector('[data-selected-name]');
      this.swatches = Array.from(this.querySelectorAll('[data-variant-exploration-swatch]'));
      this.swatchItems = this.swatches.map((swatch) => swatch.closest('.variant-exploration__swatch-item'));

      if (!this.selectedImage || !this.selectedName || !this.swatches.length) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);

      const initialSwatch = this.swatches.find((swatch) => swatch.classList.contains('is-selected')) || this.swatches[0];
      this.updateSwatchOrder(initialSwatch);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-variant-exploration-swatch]');
      if (!trigger || !this.contains(trigger)) return;

      this.selectSwatch(trigger);
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      const current = event.target.closest('[data-variant-exploration-swatch]');
      if (!current || !this.contains(current)) return;

      const currentIndex = this.swatches.indexOf(current);
      if (currentIndex === -1) return;

      event.preventDefault();

      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (currentIndex + direction + this.swatches.length) % this.swatches.length;
      const nextSwatch = this.swatches[nextIndex];

      nextSwatch.focus();
      this.selectSwatch(nextSwatch);
    }

    selectSwatch(trigger) {
      this.swatches.forEach((swatch) => {
        const isSelected = swatch === trigger;
        swatch.classList.toggle('is-selected', isSelected);
        swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      const imageSrc = trigger.dataset.imageSrc;
      const imageSrcset = trigger.dataset.imageSrcset;
      const imageAlt = trigger.dataset.imageAlt || '';
      const variantName = trigger.dataset.variantName || '';

      this.selectedImage.classList.add('is-transitioning');
      this.selectedName.classList.add('is-transitioning');

      if (imageSrc) {
        this.selectedImage.src = imageSrc;
      }

      if (imageSrcset) {
        this.selectedImage.srcset = imageSrcset;
      }

      this.selectedImage.alt = imageAlt;
      this.selectedName.textContent = variantName;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.selectedImage.classList.remove('is-transitioning');
          this.selectedName.classList.remove('is-transitioning');
        });
      });

      this.updateSwatchOrder(trigger);
    }

    updateSwatchOrder(selectedSwatch) {
      if (!selectedSwatch || this.swatches.length < 2) return;

      const selectedIndex = this.swatches.indexOf(selectedSwatch);
      if (selectedIndex === -1) return;

      const centerIndex = Math.floor(this.swatches.length / 2);

      this.swatches.forEach((swatch, index) => {
        const swatchItem = this.swatchItems[index];
        const order = (index - selectedIndex + centerIndex + this.swatches.length) % this.swatches.length;
        if (swatchItem) {
          swatchItem.style.order = String(order);
        }
      });
    }
  }

  customElements.define('variant-exploration', VariantExploration);
}